import { ActionTypes } from '../../constants/ActionTypes';
import { IreceiversOrg } from '../../interfaces';
import { IReminderReducer } from '../../interfaces/Reminder';

const INIT_STATE: IReminderReducer = {
  reminderModel: {
    letterCode: '',
    deadLine: '',
    receiverCode: [],
    text: '',
  },
  reminder: {
    pendingItems: [],
    doneItems: [],
    reminderItems: [],
    archiveItems: [],
    noteItems: [],
  },
  reminderNotify: {
    pendingItems: [],
    doneItems: [],
    reminderItems: [],
    archiveItems: [],
    noteItems: [],
  },
  isNotify: false,
  pageIndex: 0,
  notifyId: 0,
  noteId: 0,
  success: false,
  isFinal: false,
  reminderReceivers: [],
  append: false,
  onlyApproved: false,
  onlyforce: false,
  loadingInstance: true,
  endOfList: false,
  endOfPendingList: false,
  sendRequest: false,
  categoryId: 1
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_REMINDER_SUCCESS: {
      const { reminder, reminderNotify, categoryId, isNotify } =
        state;
      const s = { ...state };
      let reminderItems =
        categoryId == 2
          ? ([...action.payload.reminder.reminderItems] as any)
          : [];
      let pendingItems =
        categoryId == 3
          ? ([...action.payload.reminder.pendingItems] as any)
          : [];
      let doneItems =
        categoryId == 4
          ? ([...action.payload.reminder.doneItems] as any)
          : [];
      let noteItems =
        categoryId == 1
          ? ([...action.payload.reminder.noteItems] as any)
          : [];
      let archiveItems =
        categoryId == 5
          ? ([...action.payload.reminder.archiveItems] as any)
          : [];

      if (isNotify === true && state.append == true) {
        if (categoryId == 2 && reminderItems.length > 0)
          reminderItems = [
            ...reminderNotify.reminderItems,
            ...action.payload.reminderNotify.reminderItems,
          ] as any;
        if (categoryId == 3 && pendingItems.length > 0) {
          pendingItems = [
            ...reminderNotify.pendingItems,
            ...action.payload.reminder.pendingItems,
          ] as any;
        }
        if (categoryId == 4 && doneItems.length > 0)
          doneItems = [
            ...reminderNotify.doneItems,
            ...action.payload.reminder.doneItems,
          ] as any;
        if (categoryId == 1 && noteItems.length > 0)
          noteItems = [
            ...reminderNotify.noteItems,
            ...action.payload.reminder.noteItems,
          ] as any;
        if (categoryId == 5 && archiveItems.length > 0)
          archiveItems = [
            ...reminderNotify.archiveItems,
            ...action.payload.reminder.archiveItems,
          ] as any;
      }
      //else {
      //   if (categoryId == 2)
      //     reminderItems = [
      //       ...reminder.reminderItems,
      //       ...action.payload.reminder.reminderItems,
      //     ] as any;
      //   if (categoryId == 3)
      //     pendingItems = [
      //       ...reminder.pendingItems,
      //       ...action.payload.reminder.pendingItems,
      //     ] as any;
      //   if (categoryId == 4)
      //     doneItems = [
      //       ...reminder.doneItems,
      //       ...action.payload.reminder.doneItems,
      //     ] as any;
      //   if (categoryId == 1)
      //     noteItems = [
      //       ...reminder.noteItems,
      //       ...action.payload.reminder.noteItems,
      //     ] as any;
      //   if (categoryId == 5)
      //     archiveItems = [
      //       ...reminder.archiveItems,
      //       ...action.payload.reminder.archiveItems,
      //     ] as any;

      // }
      if (isNotify == true)
        s.reminderNotify = {
          pendingItems,
          doneItems,
          reminderItems,
          archiveItems,
          noteItems
        };
      else
        s.reminder = {
          pendingItems,
          doneItems,
          reminderItems,
          archiveItems,
          noteItems
        };
      s.loadingInstance = false;
      s.endOfPendingList =
        action.payload.reminder.pendingItems.length +
        action.payload.reminder.doneItems.length +
        action.payload.reminder.reminderItems.length +
        action.payload.reminder.archiveItems.length +
        action.payload.reminder.noteItems.length <
        10;
      s.endOfList =
        action.payload.reminder.pendingItems.length +
        action.payload.reminder.doneItems.length +
        action.payload.reminder.reminderItems.length +
        action.payload.reminder.archiveItems.length +
        action.payload.reminder.noteItems.length <
        10;

      return {
        ...s,
      };
    }

    case ActionTypes.GET_REMINDER: {
      const s = { ...state };
      const a = action.payload;
      s.isNotify = a.isNotify;

      const { onlyApproved, onlyforce } = action.payload;
      if (action.payload.pageIndex === 0) {
        s.endOfPendingList = false;
      }
      s.categoryId = action.payload.categoryId;
      s.pageIndex = action.payload;
      s.onlyApproved = onlyApproved;
      s.onlyforce = onlyforce;
      s.loadingInstance = true;
      s.append = a.append;
      return {
        ...s,
        sendRequest: true,
      };
    }

    case ActionTypes.CHANGE_REMINDER: {
      return {
        ...state,
        notifyId: action.payload.notifyId,
        isFinal: action.payload.isFinal,
      };
    }
    case ActionTypes.GET_REMINDER_RECEIVERS: {
      return {
        ...state,
        params: action.payload,
      };
    }

    case ActionTypes.FETCH_REMINDER_RECEIVERS_SUCCESS: {
      return {
        ...state,
        reminderReceivers: action.payload,
      };
    }
    case ActionTypes.CHANGE_REMINDER_STATE_ITEM_VALUE_WITH_TYPE: {
      if (action.payload.type === '' || action.payload.key === '')
        return {
          ...state,
        };

      const { reminderModel } = state as any;
      const itemKey = action.payload.key;
      const value: IreceiversOrg = {
        id:
          action.payload.value.id ||
          action.payload.value.code ||
          action.payload.value.personCode,
        text: action.payload.value.text || action.payload.value.name,
        sendSms: false,
        isConfidential: false,
        sendEmail: false,
        realName: action.payload.value.text || action.payload.value.name,
        type: 2,
      };
      const doType = action.payload.type;
      if (doType === 'ADD') {
        let compare: any;
        compare = reminderModel[itemKey].filter(
          (item: any) => item.personCode === value.id,
        );
        if (compare.length === 0) {
          compare = reminderModel[itemKey].filter(
            (item: any) => item.code === value.id,
          );
          if (compare.length === 0)
            compare = reminderModel[itemKey].filter(
              (item: any) => item.id === value.id,
            );
        }
        if (compare.length <= 0) {
          reminderModel[itemKey].push(value.id);
        }
      } else if (doType === 'DEL') {
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.personCode !== value.id,
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.code !== value.id,
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.id !== value.id,
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item !== value.id,
        );
      }

      return {
        ...state,
      };
    }
    case ActionTypes.ADD_REMINDER: {
      const addReminderModel = {
        letterCode: action.payload.letterCode,
        deadLine: action.payload.deadLine,
        receiverCode: action.payload.receiverCode,
        text: action.payload.text,
        smsNotify: action.payload.smsNotify
      };
      return {
        ...state,
        addReminderModel,
      };
    }

    default:
      return state;
  }
};
